import React, { useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "../../lib/axios.js";
import "./ResetPassword.css";

const ResetPassword = () => {
  const { token } = useParams();
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [confirm, setConfirm] = useState("");
  const [message, setMessage] = useState("");

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (password !== confirm) {
      setMessage("Passwords do not match");
      return;
    }

    try {
      const res = await axios.post(`/auth/reset-password/${token}`, { password });
      setMessage(res.data.message);
      setTimeout(() => navigate("/login"), 2000);
    } catch (err) {
      setMessage(err.response?.data?.message || "Something went wrong");
    }
  };

  return (
    <div className="loginsignup">
      <div className="loginsignup-container">
        <h2 className="loginsignup-title">Reset Password</h2>

        <form onSubmit={handleSubmit} className="loginsignup-fields">
          <div className="input-wrapper">
            <input
              type="password"
              placeholder="New password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              required
            />
          </div>
          <div className="input-wrapper">
            <input
              type="password"
              placeholder="Confirm new password"
              value={confirm}
              onChange={(e) => setConfirm(e.target.value)}
              required
            />
          </div>

          <button type="submit" className="loginsignup-button">
            Reset Password
          </button>
        </form>

        {message && <p className="input-error">{message}</p>}
      </div>
    </div>
  );
};

export default ResetPassword;
